import { render } from "./OpenOpportunityCard.vue?vue&type=template&id=cc58a14e"
import script from "./OpenOpportunityCard.vue?vue&type=script&lang=js"
export * from "./OpenOpportunityCard.vue?vue&type=script&lang=js"

import "./OpenOpportunityCard.vue?vue&type=style&index=0&id=cc58a14e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__